import React,{useState,useEffect} from 'react'
import "./VendorAudit.css"
import auditbreadcrumb_icon from "../../../../assets/audit_assets/Create_Audit/auditbreadcrumb_icon.png"
import { useDispatch } from 'react-redux';
import intomarkIcon from "../../../../assets/audit_assets/Audit_vendor/intomarkIcon.png"
import mainIcon from "../../../../assets/audit_assets/audit_details/main_icon.png"
import download_icon from '../../../../assets/reUsableTemplates_assets/dowload_icon.png';
import delete_icon from '../../../../assets/reUsableTemplates_assets/delete_icon.png';
import selected_icon from '../../../../assets/reUsableTemplates_assets/selected_icon.png';
// import { GoChevronRight } from "react-icons/go";
import headerIcon from "../../../../assets/audit_assets/audit_details/headerIcon.png";
import {getVendorWiseRecord ,getFilterVendorWiseRecord} from "./../../../../services/audit_redux/audit_actions/VendorAudit.action"
import { getClients} from './../../../../services/global_redux/globale_actions/Client.action';
import { useLocation } from 'react-router-dom';

function VendorAudit({ setLoading, showSnackbar }) {
  const location = useLocation();
    const [searchQuery, setSearchQuery] = useState("");
    const [activeTab, setActiveTab] = useState("Pending");
    const [currentData, setCurrentData] = useState([]);
    const dispatch = useDispatch();
  const [pendingData, setPendingData] = useState([]);
  const [inProgressData, setInProgressData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [header, setHeader] = useState([]);
  const [vendorClient_id, setVendorClient_id] = useState("");
  const [vendorClient_name, setVendorClient_name] = useState("");
  const [minMonth, setMinMonth] = useState('');
  const [maxMonth, setMaxMonth] = useState('');
  const [fromMonth, setFromMonth] = useState('');
  const [toMonth, setToMonth] = useState('');
  const headersByTab = {
    Pending: [
      { key: "audit_id", value: "Audit ID", icon: headerIcon },
      { key: "audit_name", value: "Audit Name", icon: headerIcon },
      { key: "period", value: "Audit Period", icon: headerIcon },
      { key: "unit_id", value: "Branch ID", icon: headerIcon },
      { key: "unit_name", value: "Branch Name", icon: headerIcon },
      { key: "templateId", value: "Templates", icon: headerIcon },
      { key: "action", value: "Action", icon: headerIcon },
    ],
    "In-Progress": [
      { key: "audit_id", value: "Audit ID", icon: headerIcon },
      { key: "audit_name", value: "Audit Name", icon: headerIcon },
      { key: "period", value: "Audit Period", icon: headerIcon },
      { key: "unit_id", value: "Branch ID", icon: headerIcon },
      { key: "unit_name", value: "Branch Name", icon: headerIcon },
      { key: "templateId", value: "Templates", icon: headerIcon },
      { key: "action", value: "Action", icon: headerIcon },
    ],
    Completed: [
      { key: "audit_id", value: "Audit ID", icon: headerIcon },
      { key: "audit_name", value: "Audit Name", icon: headerIcon },
      { key: "period", value: "Audit Period", icon: headerIcon },
      { key: "unit_id", value: "Branch ID", icon: headerIcon },
      { key: "unit_name", value: "Branch Name", icon: headerIcon },
      { key: "templateId", value: "Templates", icon: headerIcon },
      { key: "action", value: "Action", icon: headerIcon },
    ]
  };
  
  useEffect(()=>{
    if (activeTab === "Pending") setCurrentData(pendingData);
    if (activeTab === "In-Progress") setCurrentData(inProgressData);
    if (activeTab === "Completed") setCurrentData(completedData);
    setHeader(headersByTab[activeTab]);

  }, [activeTab, pendingData, inProgressData, completedData])
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const fetchData = async ()=>{
    const response = await dispatch(getVendorWiseRecord());
    if(response.success){
      setVendorClient_id(response.data.data[0].client_id)
      setVendorClient_name(response.data.data[0].client_name)
      setPendingData(response.data.data.filter((item)=>item.status === "Audit"));
      setInProgressData(response.data.data.filter((item)=>item.status === "Vendor-In-Progress"));
      setCompletedData(response.data.data.filter((item)=>item.status !== "Vendor-In-Progress" && item.status !== "Audit"));
      if(activeTab === "Pending"){
        setCurrentData(response.data.data.filter((item)=>item.status === "Audit"));
      }else if(activeTab === "In-Progress"){
        setCurrentData(response.data.data.filter((item)=>item.status === "Vendor-In-Progress"));
      }else{
        setCurrentData(response.data.data.filter((item)=>item.status !== "Vendor-In-Progress" && item.status !== "Audit"));
      }
      setMinMonth(response.data.filter[0].start);
      setMaxMonth(response.data.filter[0].end);
    }else{
      setPendingData([]);
      setCurrentData([]);
    }
  }
  
  const filteredData = Array.isArray(currentData)
  ? currentData.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    )
  : [];
  useEffect(()=>{
    fetchData();
  }, [dispatch]);
  useEffect(() => {
    if (location.state) {
      if(location.state?.message){
        showSnackbar(location.state.message, location.state.type || 'success');
      }
      if(location.state.statusData === "Audit"){
        setActiveTab("Pending");
      }else if(location.state.statusData === "Vendor-In-Progress"){
        setActiveTab("In-Progress");
      }else{
        setActiveTab("Completed");
      }
      window.history.replaceState({}, document.title);

    }
  }, [location.state]);
  const filterAuditDetailsData = async ()=>{  
    setLoading(true);
    let fromMonthFormatted = fromMonth; 
    let toMonthFormatted = toMonth;
    if(fromMonth === '' || toMonth === ''){
      showSnackbar("please enter the valid date","error")
      setLoading(false);
      return
    }
    try {
      const response = await dispatch(getFilterVendorWiseRecord( fromMonthFormatted, toMonthFormatted));
      if(response.success){
        setLoading(false);
        setVendorClient_id(response.data.data[0].client_id)
        setVendorClient_name(response.data.data[0].client_name)
        setPendingData(response.data.data.filter((item)=>item.status === "Audit"));
        setInProgressData(response.data.data.filter((item)=>item.status === "Vendor-In-Progress"));
        setCompletedData(response.data.data.filter((item)=>item.status !== "Vendor-In-Progress" && item.status !== "Audit"));
        if(activeTab === "Pending"){
          setCurrentData(response.data.data.filter((item)=>item.status === "Audit"));
        }else if(activeTab === "In-Progress"){
          setCurrentData(response.data.data.filter((item)=>item.status === "Vendor-In-Progress"));
        }else{
          setCurrentData(response.data.data.filter((item)=>item.status !== "Vendor-In-Progress" && item.status !== "Audit"));
        }
        setMinMonth(response.data.filter[0].start);
        setMaxMonth(response.data.filter[0].end);
      }else{
        setCurrentData([]);
        setLoading(false);
      }
    } catch (err) {
        console.error("Failed to fetch clients:", err);
        setLoading(false);
    }
  }
  return (
    <div className='container-fluid'>
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="create-audit-header d-flex ">
          <img src={auditbreadcrumb_icon} alt="" /><h5 className='breadcrumbdata text-white'>Audits 
          {/* <span><GoChevronRight /></span>  Audit Details */}
          </h5>
          </div>
          <div className="row">
            <div className='container-fluid vendorEditableTable-main-contaner '>
              <div className='row FormsTable-main mb-5'>
                <div className="table-header">
                  <div className="row d-flex">
                    <div className="col d-flex justify-content-between  pe-1">
                      <div className="title-data d-flex">
                        <div className="table_main_img">
                          <img src={mainIcon} alt="noImg" className='dataImg' />
                        </div>
                        <p className="dataTitle">Audits</p> 
                        <div className="FormsTable-search-box position-relative">
                          <input
                            type="text"
                            className=""
                            placeholder="Search here..."
                            style={{
                              backgroundColor: "#f9fafb",
                              border: "none",
                              width: "250px"
                            }}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                          <i
                          className="bi bi-search position-absolute"
                          style={{
                            top: "39%",
                            left: "20px",
                            transform: "translateY(-50%)",
                            color: "#9ca3af"
                          }}
                          ></i>
                        </div>
                      </div>
                      <div className='float-end d-flex'>
                        <div className="vendorClientdiv ps-2 pt-2">
                          {vendorClient_id ? <>
                            <p className='m-0'><strong>Organization ID/Name : </strong>{vendorClient_id}/{vendorClient_name}</p>
                          </>:<>
                          <p className='m-0'><strong>NO AUDITS TO WORK</strong></p>
                          </>}
                          
                        </div>
                        <div className="dataTotalEntries ms-2"><p>Total Entries :{currentData?.length}</p></div>
                        <div className={`filter_or_createcomponentn d-flex `}>
                        </div>  
                      </div>
                    </div>
                      <div className="">
                      <div className="createAuditdiv d-flex justify-content-between">
                        <div className="vendorClientdiv ps-2 pt-1 d-flex">
                          <div className="d-flex gap-3 align-items-end">
                          <div className="form-group ms-2">
                            <label>From Month</label>
                            <input type="month" className="form-control" min={minMonth} 
                            max={maxMonth} value={fromMonth} onChange={(e)=>setFromMonth(e.target.value)} 
                            />
                          </div>

                          <div className="form-group">
                            <label>To Month</label>
                            <input type="month" className="form-control" 
                            min={fromMonth} max={maxMonth} value={toMonth} onChange={(e)=>setToMonth(e.target.value)} disabled={!fromMonth}
                            />
                          </div>

                          <button className="btn btn-primary" onClick={filterAuditDetailsData}>Filter</button>

                          </div>
                        </div>
                          <div>
                            <button className='toggle-btns mt-3'>
                                <div className="d-flex gap-2">
                                    {["Pending", "In-Progress", "Completed"].map((tab) => (
                                        <button
                                        key={tab}
                                        className={` ${activeTab === tab ? "active_btn" : "all_btn"}`}
                                        onClick={() => handleTabChange(tab)}
                                        >
                                        {tab}
                                        </button>
                                    ))}
                                </div>
                            </button>
                          </div>
                      </div>
                      <div className='table-body bg-white p-0 table-roundedData mb-3'>
                        <div
                        className={`table-responsive reuseableEditable `}
                        
                        >
                          <table className='table p-0 m-0' id='dataTable'>
                              <thead className="table-light auditDetailstHeader">
                                  <tr>
                                      {header?.map((head) => (
                                      <th key={head.key}>
                                          {head.icon && <img src={head.icon} alt="" width="16" className="me-2" />}
                                          {head.value}
                                      </th>
                                      ))}
                                  </tr>
                              </thead>
                              <tbody>
                                  {filteredData?.length > 0 ? (
                                      filteredData?.map((row) => (
                                      <tr key={row.id}>
                                          {header?.map((head) => (
                                          <>
                                            {head.key === "action" ? <td style={{ minWidth:"100px" }}><a className='wrkAuditbtn' href={`audit/${row.id}`}>{activeTab === "Completed" ? <>View</>:<>Work Audit</>}</a></td> : Array.isArray(row[head.key])
                                                  ?<td> {row[head.key].join(", ")}</td>: <td key={head.key}>{row[head.key] || "-"}</td> }
                                          </>
                                          ))}
                                      </tr>
                                      ))
                                  ) : (
                                      <tr>
                                      <td colSpan={header?.length} className="text-center fs-3 fw-bold text-muted">
                                          No Record Available
                                      </td>
                                      </tr>
                                  )}
                              </tbody>
                          </table>
                        </div>
                      </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VendorAudit